import { useEffect, useRef } from 'react';
import useModalStore, { MODAL_TYPES } from '../../stores/useModalStore';

// Configuration
const RAGE_CLICK_THRESHOLD = 5; // number of clicks
const RAGE_CLICK_TIME_WINDOW = 2000; // time window in ms
const RAGE_CLICK_RADIUS = 50; // radius in px to group clicks

export default function FrictionDetector() {
    const clicksRef = useRef([]);

    useEffect(() => {
        const handleClick = (e) => {
            const now = Date.now();
            const { clientX, clientY } = e;

            // Optional: Ignore clicks inside certain classes (like the modal itself to prevent loops)
            if (e.target.closest && e.target.closest('.friction-modal')) return;

            // Remove clicks older than the time window
            clicksRef.current = clicksRef.current.filter((click) => now - click.time <= RAGE_CLICK_TIME_WINDOW);

            clicksRef.current.push({ time: now, x: clientX, y: clientY, target: e.target });

            if (clicksRef.current.length >= RAGE_CLICK_THRESHOLD) {
                // Check if they are within the distance radius
                const firstClick = clicksRef.current[0];
                const allWithinRadius = clicksRef.current.every((click) => {
                    const dx = click.x - firstClick.x;
                    const dy = click.y - firstClick.y;
                    const distance = Math.sqrt(dx * dx + dy * dy);
                    return distance <= RAGE_CLICK_RADIUS;
                });

                if (allWithinRadius) {
                    const openModal = useModalStore.getState().openModal;
                    const activeModal = useModalStore.getState().activeModal;

                    // Only trigger if the friction modal is not already open
                    if (activeModal !== MODAL_TYPES.FRICTION_MODAL) {
                        // Capture metric quietly
                        if (window.posthog) {
                            window.posthog.capture('rage_click_detected', {
                                element_tag: e.target.tagName,
                                element_text: e.target.innerText?.substring(0, 50),
                                page: window.location.pathname,
                                clickCount: clicksRef.current.length
                            });
                        }
                        openModal(MODAL_TYPES.FRICTION_MODAL);
                    }
                    // Reset clicks to prevent immediate re-triggers
                    clicksRef.current = [];
                }
            }
        };

        window.addEventListener('click', handleClick);
        return () => {
            window.removeEventListener('click', handleClick);
        };
    }, []);

    return null; // Invisible component
}
